import * as types from '../mutation-types'
const state = {
    offers: [
]
}
const actions = {
    searchOffers(_, filters) {
        return window.axios.get(`/PriceOffer/Search`, {params: filters}).then(({data})  => data)
    },
    fetchOffers({ commit }, offerType) {
        return window.axios.get(`/PriceOffer/${offerType}`).then(({data}) => {
            commit(types.STORE_OFFERS, data)
            return data;
        })
    },
    fetchOffer(_, { offerType, offerId }) {
        return window.axios.get(`/PriceOffer/${offerType}/${offerId}`).then(({data}) => {
            return data;
        })
    },
    createOffer(_, { offerType, offerData }) {
        return window.axios.post(`/PriceOffer/${offerType}`, offerData).then(({data}) => {
            return data;
        })
    },
    updateOffer(_, {offerType, offerData, offerId}) {
        return window.axios.put(`/PriceOffer/${offerType}/${offerId}`, offerData).then(({data}) => {
            return data;
        })
    },
    changeOfferStatus(_, {offerType, offerId, status}) {
        return window.axios.put(`PriceOffer/${offerType}/${offerId}/Status`, status, {
            headers: {
				'Content-Type': 'application/json',
			}
        }).then(({data}) => {
            return data;
        })
    },
    deleteOffer(_, {offerType, offerId}) {
        return window.axios.delete(`/PriceOffer/${offerType}/${offerId}`).then(({data}) => {
            return data;
        })
    },
    createEntry(_, {offerType, offerId, entry}) {
        return window.axios.post(`/priceOffer/${offerType}/${offerId}/Entries`, entry).then(response => response)
    },
    updateEntry(_, {offerType, offerId, entry, entryId}) {
        return window.axios.put(`/priceOffer/${offerType}/${offerId}/Entries/${entryId}`, entry).then(response => response)
    },
    deleteEntry(_, {offerType, offerId, entryId}) {
        return window.axios.delete(`/priceOffer/${offerType}/${offerId}/Entries/${entryId}`).then(response => response)
    }
    
}
const mutations = {
    [types.STORE_OFFERS](state, offers) {
        state.offers = offers
    }
}


const getters = {
getOfferByNo: state => no => state.offers.find(v => v.no === no)

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}